export default "__VITE_ASSET__b3c635b0__"